__turbopack_context__.v({
  "card": "j4d5Bq_card",
  "content": "j4d5Bq_content",
  "subtitle": "j4d5Bq_subtitle",
});
